import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InspectionSectionService } from '../../shared/services/index';
import { Inspection, InspectionSection } from '../../shared/models/index';
@Component({
    templateUrl: './list.component.html',
    standalone: false
})
export class SectionListPageComponent implements OnInit {
  sections: InspectionSection[];
  inspection: Inspection;

  public loading: Boolean = true;

  constructor(public sectionService: InspectionSectionService, private router: Router) {
    this.initData();
  }

  ngOnInit(): void {}

  initData(): void {
    this.sectionService.getSections(this.inspection.id).subscribe((data) => {
      this.sections = data;
      this.loading = false;
    });
  }
}
